module.exports = __webpack_public_path__ + "img/icon_KERALTY.dfb0fc5b.svg";